/* global $ */
'use strict';

function HandlebarsHelpers() {
	var Handlebars = require('handlebars');

	Handlebars.registerHelper('translate', function (i18nKey) {
		var result = $.t(i18nKey);
		return new Handlebars.SafeString(result);
	});
}

module.exports = HandlebarsHelpers;
